const KEY_MODE = 'memori-web:voice-mode';
const KEY_SILENCE = 'memori-web:voice-silence-ms';
const KEY_COMPOSE_STYLE = 'memori-web:compose-style';
const EVENT_NAME = 'memori:voice-settings-changed';

export type ComposeStyle = 'pill' | 'fab';

export interface VoiceSettings {
  mode: 'tap' | 'auto'; // tap = 通常 (mic ボタンで録音)、auto = 音声モード (pill タップで録音)
  silenceTimeoutMs: number;
}

export function getComposeStyle(): ComposeStyle {
  const v = localStorage.getItem(KEY_COMPOSE_STYLE);
  return v === 'fab' ? 'fab' : 'pill';
}

export function setComposeStyle(style: ComposeStyle) {
  localStorage.setItem(KEY_COMPOSE_STYLE, style);
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function getVoiceSettings(): VoiceSettings {
  const mode = localStorage.getItem(KEY_MODE);
  const silence = localStorage.getItem(KEY_SILENCE);
  return {
    mode: mode === 'auto' ? 'auto' : 'tap',
    silenceTimeoutMs: silence ? parseInt(silence, 10) : 30_000,
  };
}

export function setVoiceSettings(s: Partial<VoiceSettings>) {
  if (s.mode !== undefined) localStorage.setItem(KEY_MODE, s.mode);
  if (s.silenceTimeoutMs !== undefined) localStorage.setItem(KEY_SILENCE, String(s.silenceTimeoutMs));
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function subscribeVoiceSettings(fn: () => void): () => void {
  window.addEventListener(EVENT_NAME, fn);
  return () => window.removeEventListener(EVENT_NAME, fn);
}
